import { getExperimentTreatment as getExperimentTreatmentSelector } from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { Experiment } from '@ms/yammer-data/dist/state/types';
import { useCurrentLocale } from '@ms/yammer-i18n-react';
import { useRelayContext } from '@ms/yammer-relay/dist/environment';
import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';

import type { DataLoaderModule, PageLoadData } from '../types';

type UsePreloadPageDataCallback = (
  setPageLoadData: React.Dispatch<React.SetStateAction<PageLoadData>>
) => (dataLoader: () => Promise<DataLoaderModule>, routeParams: Record<string, unknown>) => void;
export const usePreloadPageDataCallback: UsePreloadPageDataCallback = (setPageLoadData) => {
  const dispatch = useDispatch();
  const store = useStore();
  const { environment: relayEnvironmentPromise } = useRelayContext();
  const currentLocale = useCurrentLocale();

  const getExperimentTreatment = useCallback(
    (experiment: Experiment) => getExperimentTreatmentSelector(store.getState(), experiment),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return useCallback(
    async (dataLoader, routeParams) => {
      const { loadData } = await dataLoader();
      const data = await loadData({
        dispatch,
        relayEnvironmentPromise,
        routeParams,
        currentLocale,
        getExperimentTreatment,
      });

      if (data) {
        setPageLoadData?.(data);
      }
    },
    [setPageLoadData, relayEnvironmentPromise, dispatch, currentLocale, getExperimentTreatment]
  );
};
